import { useMemo, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router";

import { ConfirmModal, Modal } from "@prequel/shared-components";

import { useDeleteRecipient } from "@/api/queries/recipients";
import DangerZone from "@/components/DangerZone";
import { ExistingRecipient } from "@/types";

type RecipientAdminProps = {
  recipient: ExistingRecipient;
};

const RecipientAdmin = () => {
  const { recipient } = useOutletContext<RecipientAdminProps>();
  const { recipientID } = useParams<{ recipientID: string }>();
  const navigate = useNavigate();
  const deleteRecipientMutation = useDeleteRecipient();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const onDelete = () => {
    setShowDeleteModal(true);
  };

  const onConfirmDelete = () => {
    setShowDeleteModal(false);
    if (recipient) {
      deleteRecipientMutation.mutate({
        recipientID: recipient.id,
        redirectPath: "/recipients",
      });
    }
  };

  const dangerZoneActions = useMemo(
    () => [
      {
        label: "Edit recipient",
        description: "Edit recipient fields.",
        buttonText: "Edit Recipient",
        onClick: () => navigate(`/recipients/${recipientID}/edit`),
      },
      {
        label: "Delete recipient",
        description: "Once you delete a recipient, the action cannot be undone.",
        buttonText: "Delete Recipient",
        onClick: onDelete,
      },
    ],
    [recipientID, navigate],
  );

  return (
    <div className="mt-6 space-y-10">
      <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
        <ConfirmModal
          title="Delete recipient"
          message="Are you sure you want to delete this recipient? This action cannot be undone."
          onConfirm={onConfirmDelete}
          confirmButtonText="Delete"
          onCancel={() => setShowDeleteModal(false)}
        />
      </Modal>
      <DangerZone actions={dangerZoneActions} />
    </div>
  );
};

export default RecipientAdmin;
